import { Badge } from 'ui/badge';
import { mapStateToBadgeInfo } from 'modules/experiments/utils';
import { ExperimentState } from 'modules/graphql';

type StatusBadgeProps = {
  state: ExperimentState;
};

export const StatusBadge = ({ state }: StatusBadgeProps) => {
  if (!state) {
    return null;
  }
  const { variant, label } = mapStateToBadgeInfo(state as ExperimentState);
  return <Badge variant={variant}>{label}</Badge>;
};
